(() => {
  'use strict';

  const summarySelector = '[data-cbm-price-summary]';

  function parseVariants(summary) {
    const data = summary.querySelector('[data-cbm-price-summary-variants]');
    if (!data) return new Map();

    try {
      const variants = JSON.parse(data.textContent || '[]');
      if (!Array.isArray(variants)) return new Map();
      return new Map(variants.filter((variant) => variant && variant.id != null)
        .map((variant) => [String(variant.id), variant]));
    } catch (error) {
      return new Map();
    }
  }

  function isPositiveSaving(variant) {
    return Boolean(
      variant &&
      variant.hasSavings === true &&
      typeof variant.compareAtPrice === 'string' && variant.compareAtPrice &&
      typeof variant.savings === 'string' && variant.savings
    );
  }

  function updateSummary(summary, variants, variantId) {
    const variant = variants.get(String(variantId || ''));
    if (!variant || typeof variant.price !== 'string') return;

    const price = summary.querySelector('[data-cbm-price-summary-price]');
    const compare = summary.querySelector('[data-cbm-price-summary-compare]');
    const savings = summary.querySelector('[data-cbm-price-summary-savings]');
    const badge = summary.querySelector('[data-cbm-price-summary-badge]');
    const positiveRegions = summary.querySelectorAll('[data-cbm-price-summary-positive]');
    const positive = isPositiveSaving(variant);

    if (price) price.textContent = variant.price;
    if (compare) compare.textContent = variant.compareAtPrice;
    if (savings) savings.textContent = variant.savings;
    if (badge) {
      badge.textContent = positive ? `${variant.percent}% cheaper` : '';
      badge.hidden = !positive;
    }
    positiveRegions.forEach((region) => {
      region.hidden = !positive;
    });
    const primarySummary = document.querySelector('[id^="MainProduct-"] [data-cbm-price-summary]');
    if (primarySummary === summary && /\/products\//.test(window.location.pathname)) {
      document.querySelectorAll('.cbm-mobile-promotion__offer, [data-cbm-header-promo-offer]').forEach((promo) => {
        promo.textContent = positive ? `${variant.percent}% CHEAPER` : "DON'T MISS OUT";
        const badgeClass = promo.hasAttribute('data-cbm-header-promo-offer')
          ? 'cbm-refined-announcement__discount' : 'cbm-mobile-promotion__discount';
        promo.classList.toggle(badgeClass, positive);
      });
      document.querySelectorAll('[data-cbm-header-promo-info]').forEach((info) => {
        info.hidden = !positive;
      });
    }
    summary.dataset.cbmPriceSummaryVariant = String(variant.id);
  }

  function findForm(summary) {
    const formId = summary.dataset.cbmProductFormId;
    if (!formId) return null;
    return document.getElementById(formId);
  }

  function currentVariantInput(form) {
    return form && form.querySelector('[name="id"]');
  }

  function watchInputValue(input, schedule) {
    if (!input || input.dataset.cbmPriceSummaryValueWatch === 'true') return;
    input.dataset.cbmPriceSummaryValueWatch = 'true';

    const descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    if (descriptor && descriptor.get && descriptor.set) {
      try {
        Object.defineProperty(input, 'value', {
          configurable: true,
          enumerable: descriptor.enumerable,
          get() {
            return descriptor.get.call(this);
          },
          set(value) {
            const previous = descriptor.get.call(this);
            descriptor.set.call(this, value);
            if (descriptor.get.call(this) !== previous) schedule();
          }
        });
      } catch (error) {
        // Native change/input events and the narrow attribute observer remain available.
      }
    }

    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  function bindSummary(summary) {
    if (summary.dataset.cbmPriceSummaryBound === 'true') return;

    const form = findForm(summary);
    const variants = parseVariants(summary);
    if (!form || !variants.size) return;

    summary.dataset.cbmPriceSummaryBound = 'true';
    const root = summary.closest('[id^="MainProduct-"]') || form;
    let queued = false;
    const refresh = () => {
      const input = currentVariantInput(form);
      if (input) watchInputValue(input, schedule);
      updateSummary(summary, variants, input && input.value);
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      window.setTimeout(() => {
        queued = false;
        refresh();
      }, 0);
    };

    // Variant controls can use form= rather than be descendants of the primary form.
    root.addEventListener('change', schedule, true);
    root.addEventListener('input', schedule, true);
    root.addEventListener('variant:change', schedule);
    root.addEventListener('product:variant-change', schedule);

    refresh();
  }

  function initialize() {
    document.querySelectorAll(summarySelector).forEach(bindSummary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
